<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1>Calendar</h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section contact-page-main col-12">
            <!--bottom-contact-detail-->


            <div class="container">
                <div class="calendar">
                    <div class="mb-4 keysContainer pull-left w-100">
                        <template v-for="(mainclass, index) in keysArr">
                            <template v-if="mainclass.is_view == 1">
                                <button id="key" @click="changeVisible(mainclass.id)" :title="mainclass.name" class="mt-2 mr-3 btn btn-primary pull-left"
                                        :style="'color:'+ mainclass.text_color + ';background:'+ mainclass.background_color">
                                    {{ mainclass.name }}
                                </button>
                            </template>
                            <template v-else>
                                <button id="key" @click="changeVisible(mainclass.id)" :title="mainclass.name" class="mt-2 mr-3 btn btn-secondary pull-left">
                                    {{ mainclass.name }}
                                </button>
                            </template>
                        </template>
                    </div>
                    <div class="fullCalendarView">
                        <div class="callendarButtons">
                            <div class="nevCalendar">
                                <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                            </div>
                            <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                            <button id="backToCalendar" @click="backToCalendar()" class="btn btn-success pull-right" style="display: none;margin-left: 5px; padding: 7px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            <!--Search-->
                            <!--<form class="search-form" role="search">-->
                            <div class="btn btn-success form-group pull-right searchBtn" id="search" @click="searchBtnClick()">
                                <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                                <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                                <span class="search-label"><i class="fa fa-search"></i></span>
                            </div>
                        </div>
                        <full-calendar
                                id="EVcalendar"
                                @day-click="eventSelected($event)"
                                :events="display_events"
                                :config="config"
                                ref="EVcalendar"
                                @eventRender="eventRender($event, $element, $view)">
                        </full-calendar>
                        <!--Event List-->
                        <div id="list" class="list-group">
                            <template v-for="(text, index) in classList">
                                <button @click="onSearchListClick(text, 'search')" type="button" class="list-group-item list-group-item-action">{{text.title}}
                                    <span class="pull-right">{{text.name}} {{text.start_date_time}}</span>
                                    <!--<span v-show="text.recursive_type == null" class="pull-right">{{text.start_date_time}}</span>-->
                                </button>
                            </template>
                        </div>
                        <!--End Event List-->
                    </div>
                
                
                    <div class="large-modal">
                        <!--Large Modal Popup-->
                        <b-modal ref="showClassDetailModel" id="modallg" size="lg" title="Large Modal">
                            We use cookies to improve your website experience
                            <div class="row no-margin">
                                <div class="col-12 forms-block">
                                    <h1>Class Name</h1>
                                </div>
                                <div class="col-6 forms-block">
                                    <template>
                                        <button class="form-control btn-danger">Cancel Registration</button>
                                    </template>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><span>Link :</span></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <label class="form-label">Data</label>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><span>Link :</span></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <label class="form-label">Data</label>
                                    </div>
                                </div>
                            </div>
                        </b-modal>
                        <!--Large Modal Popup-->
                    </div>





                    </div>
                </div>
            </div>
        </div>
        <!--bottom-contact-detail-->
</template>
<script>
    import Vue from "vue";
    import {HTTP} from '../../http-common.js';
    import vSelect from 'vue-select';
    import {commonMixins} from '../../mixins/commonMixins';
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import EventBus from "./../event-bus";
    import moment from 'moment';
    import commonModel from "../CommonModelForClass/CommonModel"
    import PopOver from 'bootstrap-vue/src/utils/popover.class'

    // ES6 Modules or TypeScript
    import Swal from 'sweetalert2';

    var self;
    export default {
        name: 'calendar',
        components: {
            'v-select': vSelect,
            'full-calendar': FullCalendar,
            "common-model" : commonModel
        },
        mixins: [commonMixins],
        data() {
            return {
                classList : [],
                modelData : [],
                loginRoleId : 0,
                loginRoleName : "",
                startDate: 0,
                endData: 0,
                config: {
                    /*'weekends': false,*/
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "Classes Not Available",
                    eventClick: (event) => {
                        this.selected = event;
                        this.redirectToUpdate(event);
                        //this.loadTheEventData(event);
                    },
                    eventMouseover: (event,eventData,data) => {
                        //this.loadTheEventData(event);
                        //self.showToolTip(event);
                    },
                    /* eventRender: (event, element, view) => {
                        element.prop('id', moment(event.start, "YYYY-MM-DD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss") + "_" + event.id);
                        element.prop('style', element.attr("style") + ';cursor: pointer;');
                        var eventTitle = "Title : " + event.title_without_time + "\n";
                        //eventTitle = eventTitle + "Timezone : " + event.timezone_name + "\n";
                        eventTitle = eventTitle + "Start Time : " + event.start_date + "\n";
                        var i;
                        if(event.participant_array.length > 0){
                            eventTitle = eventTitle + "Participant : " + "\n";
                        }
                        for (i = 0; i < event.participant_array.length; i++) {
                            eventTitle = eventTitle + event.participant_array[i] + "\n";
                        }
                        element.prop('title', eventTitle);
                    }, */
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',

                    }
                },
                events: [],
                display_events:[],
                selected: {},
                selectedEventData: [],
                eventList: [],
                searchEvents: '',
                mainClassList:[],
                selectedClassMaster:'all',
                keysArr: [],
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.loadClasses();
            self.showModalData=true;
            self.setActiveMenu('calendarclass');
            EventBus.$emit("menu-selection-changed", "calendarclass");
            self.loginRoleId = self.$store.state.roleId;
            self.loginRoleName = self.$store.state.roleName;
            self.startDate = self.$refs.EVcalendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.EVcalendar.fireMethod('getView').end.format();
            self.loadCalendarEvents();
            localStorage.setItem("selected_master_class",'all');
            self.selectedClassMaster = localStorage.getItem("selected_master_class");
            
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("login-user-info", true, userJson["email"], userJson["first_name"], userJson["last_name"]);
            }
            
            $("#list").hide();
            $("#backToCalendar").hide();

            $(document).ready(function () {
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#EVcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#EVcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
        },
        watch: {
            searchEvents: function (searchEvents) {
                var self = this;
                self.searchEvent();
            },
        },
        methods: {
            eventRender: (event, element, view) => {
                element.prop('id', moment(event.start, "YYYY-MM-DD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss") + "_" + event.id);
                element.prop('style', element.attr("style") + ';cursor: pointer;');
                var eventTitle = "Title : " + event.title_without_time + "\n";
                //eventTitle = eventTitle + "Timezone : " + event.timezone_name + "\n";
                eventTitle = eventTitle + "Start Time : " + event.start_date + "\n";
                var i;
                if(event.participant_array.length > 0){
                    eventTitle = eventTitle + "Participant : " + "\n";
                }
                for (i = 0; i < event.participant_array.length; i++) {
                    eventTitle = eventTitle + event.participant_array[i] + "\n";
                }
                element.prop('title', eventTitle);
            },
            changeVisible(id) {
                var self = this;
                var activeKey = [];
                var tempArr = self.keysArr;
                self.keysArr = [];
                $.each(tempArr, function (i) {
                    if (id == tempArr[i].id) {
                        tempArr[i].is_view = (tempArr[i].is_view == 1) ? 0 : 1;
                    }
                    if (tempArr[i].is_view == 1) {
                        activeKey.push(tempArr[i].id);
                    }
                    self.keysArr.push(tempArr[i]);
                });
                self.$nextTick(function () {
                    self.display_events = [];
                    $.each(self.events, function (i) {
                        if ($.inArray(self.events[i].c_id,activeKey) != "-1") {
                            self.display_events.push(self.events[i]);
                        }
                    });
                    self.$refs.EVcalendar.$emit('refetch-events');
                });
            },
            loadClasses: function() {
                self.firstLoad = 1;
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        load: 'all'
                    }
                };
                HTTP.get("/class-master/list", config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            self.mainClassList = response.data.content.row;
                            self.keysArr = [];
                            $.each(response.data.content.row, function (i) {
                                response.data.content.row[i].is_view = 1;
                                self.keysArr.push(response.data.content.row[i]);
                            });
                            // $('.loading-container').hide();
                            self.$refs.EVcalendar.$emit('refetch-events');
                        }
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            showToolTip(info){
                $(info.el).tooltip({ title: info.id });
                // CONFIG FOR THE PopOver CLASS
                const config = {
                title: 'I am a title',
                content: "This text will show up in the body of the PopOver",
                placement: 'auto', // can use any of Popover's placements(top, bottom, right, left etc)
                container: 'null', // can pass in the id of a container here, other wise just appends to body
                boundary: 'scrollParent',
                boundaryPadding: 5,
                delay: 0,
                offset: 0,
                animation:true,
                trigger: 'hover', // can be 'click', 'hover' or 'focus'
                html: false, // if you want HTML in your content set to true.
                }

                const target = info.el;
                const toolpop = new PopOver(target, config, self.$root);
            },
            loadTheEventData : function (event) {
                if (self.loginRoleName != "Participant" && self.loginRoleName != "") {
                } else {
                     
                }
                self.$refs.showClassDetailModel.hide();
                //alert(self.selectedEventData.id);
                let date = event.start._i
                let selectedDate =  moment(new Date(date)).format("YYYY-MM-DD");
                let id = event.id;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    class_id: id,
                    selected_date: selectedDate,
                };
                HTTP.post("/class/getmodeldata/by-id", fields, config)
                    .then(function (response) {
                        self.$refs.showClassDetailModel.show();
                        //self.events = response.data.content;
                        //self.$refs.EVcalendar.$emit('refetch-events');
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            onSearchListClick : function (id) {
                if (self.$store.state.roleName != 'Participant') {
                    self.$router.push({ name: 'UpdateClass', params : { id : id.id}});
                } else {
                    self.$router.push({ name: 'CommonClassDetailPage'})
                    EventBus.$emit('CLASS_COMMON_PAGE', id, "search_view");
                }

            },
            searchEvent() {

                var self = this;
                var timedifference = new Date().getTimezoneOffset();
                if (self.searchEvents == "") {
                    self.classList = [];
                }
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                        params: {
                            search: self.searchEvents,
                            start_date: self.startDate,
                            end_date: self.endDate,
                        }
                    };
                    HTTP.get("class/searchclass", config)
                        .then(function (response) {
                            self.classList = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    localStorage.removeItem("profileColor");
                                    localStorage.removeItem("user_role");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
                }
            },
            backToCalendar() {
                var self = this;
                $(".searchBtn").removeClass("sb-search-open");
                $("#EVcalendar").show();
                $("#refresh").show();
                $(".nevCalendar").show();
                self.eventList = '';
                $("#backToCalendar").hide();
                $("#list").hide();
                $(".keysContainer").show();
                //e.stopPropagation();
            },
            searchBtnClick() {
                var self = this;
                $(".searchBtn").addClass("sb-search-open");
                $("#EVcalendar").hide();
                $("#refresh").hide();
                $(".nevCalendar").hide();
                $("#backToCalendar").show();
                $("#list").show();
                $(".keysContainer").hide();
                //e.stopPropagation();
            },
            cancelRegistration : function () {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));

                var fields = {
                    class_id: self.selected.id,
                    user_id : userObj.id
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/cancelregister', fields, config).
                then(response => {
                    if (response.data.status == "success") {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        // Swal.fire('', response.data.message, 'success');
                        $('.close').click();
                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            registerToClass : function() {
                let selectedDate = moment(new Date(self.selected.start)).format("YYYY-MM-DD");
                let userObj = JSON.parse(localStorage.getItem("user_obj"));

                var fields = {
                    class_id: self.selected.id,
                    user_id : userObj.id,
                    selected_date : selectedDate
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/register', fields, config).
                then(response => {
                    if (response.data.status == "success") {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        // Swal.fire('', response.data.message, 'success');
                        $('.close').click();
                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            getClassDetailsById: function (id, flag) {
                let userObj = JSON.parse(localStorage.getItem("user_obj"));
                let selectedDate = moment(new Date(self.selected.start)).format("YYYY-MM-DD");

                if (flag == "search") {
                    var fields = {
                        class_id: id,
                        user_id : userObj.id,
                        selected_date : ''
                    };
                } else {
                    var fields = {
                        class_id: self.selected.id,
                        user_id : userObj.id,
                        selected_date : selectedDate
                    };
                }


                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/getmodeldata', fields, config).
                then(response => {
                    if (response.status == 200) {
                        $('#openModel').click();
                        self.modelData = response.data.content;

                        switch (self.modelData.week_day) {
                            case "1" :
                                self.modelData.week_day = "Monday";
                                break;
                            case "2" :
                                self.modelData.week_day = "Tuesday";
                                break;
                            case "3" :
                                self.modelData.week_day = "Wednesday";
                                break;
                            case "4" :
                                self.modelData.week_day = "Thursday";
                                break;
                            case "5" :
                                self.modelData.week_day = "Friday";
                                break;
                            case "6" :
                                self.modelData.week_day = "Saturday";
                                break;
                            case "7" :
                                self.modelData.week_day = "Sunday";
                                break;
                        }
                    }
                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            showModel() {
                self.getClassDetailsById();
            },
            eventSelected : function(date) {
                let selectedDate = moment(new Date(date)).format("YYYY-MM-DD");
                let todayDate = moment(new Date()).format('YYYY-MM-DD');

                selectedDate = new Date(selectedDate);
                todayDate = new Date(todayDate);

                if (todayDate.getTime() > selectedDate.getTime()) {
                    if (self.loginRoleName == "Participant") {
                    } else {
                        Swal.fire('', 'Please Select Future Date!', 'error');
                    }
                } else {
                    if (self.loginRoleName == "Participant") {
                        self.showModel();
                    } else {
                        let formatDate  = moment(date).format("MM/DD/YYYY");
                        this.$store.commit("setDate", formatDate);
                        self.$router.push({name : "AddClass"});
                    }
                }
            },
            redirectToUpdate(event) {
                if (self.loginRoleName != "Participant" && self.loginRoleName != "") {
                    self.$router.push({name : "UpdateClass", params : { id : self.selected.id}});
                } else {
                    EventBus.$emit('CLASS_COMMON_PAGE', event, "calendar_view");
                    self.$router.push({ name: 'CommonClassDetailPage'})
                    // self.showModel();
                }
            },
            refreshEvents() {
                var refresh = true;
                self.selectedClassMaster = 'all';
                if (refresh) {
                    self.loadCalendarEvents();
                }
            },

            previousMonth() {
                self.$refs.EVcalendar.fireMethod('prev');
                self.startDate = self.$refs.EVcalendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.EVcalendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            nextMonth() {
                self.$refs.EVcalendar.fireMethod('next');
                self.startDate = self.$refs.EVcalendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.EVcalendar.fireMethod('getView').end.format();
                self.loadCalendarEvents();
            },
            loadCalendarEvents() {
                self.selected = {};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    start_date: self.startDate,
                    end_date: self.endDate,
                    selectedClassMaster:self.selectedClassMaster
                };
                HTTP.post("/class/getevents", fields, config)
                    .then(function (response) {
                        self.events = self.display_events = response.data.content;
                        self.$nextTick(function() {
                            self.keysArr = [];
                            $.each(response.data.content.keys, function (i) {
                                response.data.content.keys[i].is_view = 1;
                                self.keysArr.push(response.data.content.keys[i]);
                                self.$refs.EVcalendar.$emit('refetch-events');
                            });
                        });
                        self.loadClasses();
                        //self.$refs.EVcalendar.$emit('refetch-events');
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Class/ClassCalender.vue